import { type Routes } from '@angular/router';
import { notAuthGuard, workupGuard } from './core/guards';
import { courtsResolver, stateCountryResolver } from '@td/dictionaries';
import { RootRedirectComponent } from './core/components/root-redirect/root-redirect.component';

export const routes: Routes = [
  {
    path: '',
    component: RootRedirectComponent,
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadChildren: () => import('./features/login/pages/common/common-login.routing'),
    canActivate: [notAuthGuard],
  },
  {
    path: 'login/lts',
    loadChildren: () => import('./features/login/pages/lts/lts.routing'),
    canActivate: [notAuthGuard],
    resolve: { courtsResolver, stateCountryResolver },
  },
  {
    path: 'login/armed-forces-traffic',
    loadChildren: () => import('./features/login/pages/aft/aft-login.routing'),
    canActivate: [notAuthGuard],
  },
  {
    path: 'login/usdc-federal',
    loadChildren: () => import('./features/login/pages/federal/federal-login.routing'),
    canActivate: [notAuthGuard],
  },
  {
    path: 'sms-notifications',
    loadChildren: () => import('./features/phone-notifications/pages/phone-notifications.routing'),
    canActivate: [notAuthGuard],
  },
  {
    path: 'citation',
    loadChildren: () => import('./features/citation/pages/citation.routing'),
    canActivate: [
      workupGuard([
        'TRAFFIC',
        'PARKING',
        'TOWING',
        'MISDEMEANOR',
        'ARMED_FORCES_TRAFFIC',
        'FEDERAL',
        'FIRE_ENFORCEMENT',
      ]),
    ],
  },
  {
    path: 'ctw',
    loadChildren: () => import('./features/ctw/pages/ctw.routing'),
    canActivate: [workupGuard('CTW')],
  },
  {
    path: 'lts',
    loadChildren: () => import('./features/lts/pages/lts.routes'),
    canActivate: [workupGuard(['LTS'], '/login/lts/switcher')],
  },
  {
    path: 'errors',
    loadChildren: () => import('./features/errors/pages/errors.routing'),
  },
  {
    path: '**',
    redirectTo: '/',
    pathMatch: 'full',
  },
];
